import { RefObject, useEffect } from 'react';

// This hook manages the data-is-open attribute on submenu elements,
// toggling it on hover and focus events. This attribute serves as a
// selector for Pendo to track submenu interactions.

export const useSetSubMenuToActive = ({
  element,
  activeFunction,
  inActiveFunction,
  isSuccess,
}: {
  element: RefObject<HTMLLIElement | null>;
  activeFunction: () => void;
  inActiveFunction: () => void;
  isSuccess: boolean;
}) => {
  useEffect(() => {
    const menuItem = element.current;
    if (isSuccess && menuItem) {
      // Define handlers once to ensure same reference
      const handleActive = () => activeFunction();
      const handleInactive = () => inActiveFunction();

      ['mouseover', 'focusin'].forEach((e: string) => {
        menuItem?.addEventListener(e, handleActive);
      });
      ['mouseleave', 'focusout'].forEach((e: string) => {
        menuItem?.addEventListener(e, handleInactive);
      });

      return () => {
        ['mouseover', 'focusin'].forEach((e: string) => {
          menuItem?.removeEventListener(e, handleActive);
        });
        ['mouseleave', 'focusout'].forEach((e: string) => {
          menuItem?.removeEventListener(e, handleInactive);
        });
      };
    }
    return undefined;
  }, [inActiveFunction, activeFunction, element, isSuccess]);
};
